import { api } from "../../lib";

export interface SourceDefaultStain {
  id: string;
  sourceId: string;
  stainId: string;
  gStainId: string | null;
  findingsTriggers: string[] | null;
  findingsIgnoreTriggers: string[] | null;
  excludeSubsiteIds: string[] | null;
  excludeWhenNoSubsite: boolean;
  createdAt: string;
  // Relations
  source?: { id: string; name: string } | null;
  stain?: { id: string; code: string; description: string } | null;
  gStain?: { id: string; code: string; description: string } | null;
}

export interface SourceDefaultStainSearchParams {
  search?: string;
  sourceIds?: string[];
  stainIds?: string[];
}

export interface CreateSourceDefaultStainData {
  sourceId: string;
  stainId: string;
  gStainId?: string | null;
  findingsTriggers?: string[] | null;
  findingsIgnoreTriggers?: string[] | null;
  excludeSubsiteIds?: string[] | null;
  excludeWhenNoSubsite?: boolean;
}

export interface UpdateSourceDefaultStainData
  extends Partial<CreateSourceDefaultStainData> {
  id: string;
}

export const sourceDefaultStainsService = {
  getAll: async (params?: SourceDefaultStainSearchParams) => {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.append("search", params.search);
    if (params?.sourceIds?.length)
      searchParams.append("sourceIds", params.sourceIds.join(","));
    if (params?.stainIds?.length)
      searchParams.append("stainIds", params.stainIds.join(","));

    const queryString = searchParams.toString();
    const url = queryString
      ? `/admin/source-default-stains?${queryString}`
      : "/admin/source-default-stains";

    return api.get<SourceDefaultStain[]>(url);
  },

  getById: async (id: string) => {
    return api.get<SourceDefaultStain>(`/admin/source-default-stains/${id}`);
  },

  getBySourceId: async (sourceId: string) => {
    return api.get<SourceDefaultStain[]>(
      `/admin/sources/${sourceId}/default-stains`
    );
  },

  create: async (data: CreateSourceDefaultStainData) => {
    return api.post<SourceDefaultStain>("/admin/source-default-stains", data);
  },

  update: async ({ id, ...data }: UpdateSourceDefaultStainData) => {
    return api.put<SourceDefaultStain>(
      `/admin/source-default-stains/${id}`,
      data
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/source-default-stains/${id}`);
  },
};
